import { render, staticRenderFns } from "./mixes.vue?vue&type=template&id=2fa3f62e&"
import script from "./mixes.vue?vue&type=script&lang=js&"
export * from "./mixes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports